import React,{useState} from "react";

function QuizView ({quizData, onAnswer, onRestart}) {
    const [quizStarted, setQuizStarted] = useState(false);

    return (
        <div className = "quiz-view">

          {!quizStarted ? 
          (
            <>
              <h1 className = "quiz-title">Welcome to the ArtXplorer quiz!</h1>
              <h2>Test your art knowledge</h2>
              <button className="login-button" onClick={() => setQuizStarted(true)}>Start the Quiz!</button>
            </>
          ) : 


          (
            <div className = "quiz-questions">

              {quizData ? 
              (
                <>
                  <h3>{quizData.question}</h3>
                  <div className = "quiz-options">
                    {quizData.options.map((option, index) => 
                    (
                      <div key = {index} className = "quiz-display">
                        <img src = {option.image} alt = {option.text}/>
                      <button key= {index} onClick= {() => onAnswer(option)}>{option.text}</button>
                      </div>
                    ))}
                  </div>
                </>
              ) : 


              (<p>Processing...</p>)}
              <button className="browse-button" onClick={onRestart}>Restart Quiz</button>
            </div>
          )}
        </div>
      );

};

export default QuizView;